import {
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    HostListener,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    SimpleChanges,
    ViewChild,
} from '@angular/core';

export enum MoreOptionAction {
    EDIT = 'EDIT',
    DUPLICATE = 'DUPLICATE',
    COPY = 'COPY',
    DELETE = 'DELETE',
    CLEAR = 'CLEAR',
}

export interface MoreOption {
    action: MoreOptionAction;
    string: string;
    disabled?: boolean;
}

@Component({
    selector: 'app-more-options-dropdown',
    templateUrl: './more-options-dropdown.component.html',
    styleUrl: './more-options-dropdown.component.css',
    standalone: false,
})
export class MoreOptionsDropdownComponent implements OnInit, OnChanges, OnDestroy {
    @Input() options: MoreOption[] = [];
    @Input() isOpen = false;

    @Output() toggle = new EventEmitter<void>();
    @Output() optionSelected = new EventEmitter<MoreOptionAction>();

    @ViewChild('trigger') trigger!: ElementRef;

    optionsTop = '0px';
    optionsLeft = '0px';

    private scrollContainer: HTMLElement | null = null;

    constructor(
        private cdr: ChangeDetectorRef,
        private eRef: ElementRef
    ) {}

    @HostListener('window:resize')
    onResize(): void {
        if (this.isOpen) {
            this.toggle.emit();
        }
    }

    @HostListener('window:scroll', ['$event'])
    onWindowScroll(): void {
        if (this.isOpen) {
            this.toggle.emit();
        }
    }

    @HostListener('document:click', ['$event'])
    clickOut(event: MouseEvent): void {
        if (this.isOpen && !this.eRef.nativeElement.contains(event.target)) {
            this.toggle.emit();
        }
    }

    private onScroll = (): void => {
        if (this.isOpen) {
            this.toggle.emit();
        }
    };

    ngOnInit(): void {
        let parent: HTMLElement | null = this.eRef.nativeElement.parentElement;
        while (parent && parent !== document.body) {
            const { overflowY, overflow } = window.getComputedStyle(parent);
            if (/(auto|scroll)/.test(overflowY + overflow)) {
                this.scrollContainer = parent;
                break;
            }
            parent = parent.parentElement;
        }
        this.scrollContainer?.addEventListener('scroll', this.onScroll, { passive: true });
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['isOpen']?.currentValue === true) {
            this.updatePosition();
        }
    }

    ngOnDestroy(): void {
        this.scrollContainer?.removeEventListener('scroll', this.onScroll);
    }

    toggleDropdown(): void {
        this.toggle.emit();
    }

    onSelect(option: MoreOption): void {
        if (option.disabled) {
            return;
        }

        this.optionSelected.emit(option.action);
    }

    private updatePosition(): void {
        if (!this.trigger) {
            return;
        }

        const position = this.trigger.nativeElement.getBoundingClientRect();
        this.optionsTop = `${position.bottom + 4}px`;
        this.cdr.detectChanges();
    }
}
